<template>

  <b-modal
      :id="id"
      ref="modal"
      :title="title"
      :size="'lg'"
      :busy="busy"
      no-close-on-backdrop
      @show="showModal()">

    <template #modal-footer="{ ok }">
      <t-button @click="ok()" class="pr-5 pl-5 ml-3" text="Fechar" primary/>
    </template>

    <b-row>
      <t-input v-model="form.product.productCodeLabel" label="Cód. Produto" cols="3" fixed/>
      <t-input v-model="form.product.name" label="Produto" cols="7" fixed/>
      <t-input v-model="form.product.unit" label="Un." cols="2" fixed/>
    </b-row>

    <b-row>
      <t-input v-model="form.product.model" label="Modelo" cols="4" fixed/>
      <t-input v-model="form.product.groupProduct" label="Grupo" cols="4" fixed/>
      <t-input v-model="form.stockPlaceProductInside" label="Localização" cols="4" fixed/>
    </b-row>

    <transition  v-if="searchByType === ''" name="fade">

      <div class="no-gutters row mt-3 mb-3">

        <div class="col-sm-6 col-md-4 col-xl-4">

          <div
              @click="extractStock()"
              v-b-tooltip.hover.ds500 title="Detalhar Estoque"
              class="card no-shadow b-radius border container_stock_total bg-transparent widget-chart text-left"
              style="padding: 0; margin: 15px; padding-top: 10px">
            <div class="icon-wrapper rounded-circle">
              <i class="lnr-layers text-dark opacity-8"></i></div>
            <div class="widget-chart-content">
              <div class="widget-subheading">Qtd. Estoque</div>
              <div class="widget-numbers">{{ form.quantityStock }}</div>

            </div>
          </div>
          <div class="divider m-0 d-md-none d-sm-block"></div>
        </div>
        <div class="col-sm-6 col-md-4 col-xl-4">
          <div
              @click="extractReserved()"
              v-b-tooltip.hover.ds500 title="Detalhar Reservas"
              class="card no-shadow b-radius border container_stock_total bg-transparent widget-chart text-left"
              style="padding: 0; margin: 15px; padding-top: 10px">
            <div class="icon-wrapper rounded-circle">

              <i class="lnr-hourglass"></i></div>
            <div class="widget-chart-content">
              <div class="widget-subheading">Qtd. Reservado</div>
              <div class="widget-numbers"><span>{{ form.quantityReserved }}</span></div>
            </div>
          </div>
          <div class="divider m-0 d-md-none d-sm-block"></div>
        </div>
        <div class="col-sm-12 col-md-4 col-xl-4">
          <div
              @click="extractAvailable()"
              v-b-tooltip.hover.ds500 title="Detalhar Disponível"
              class="card no-shadow b-radius border container_stock_total text-success widget-chart text-left"
              style="padding: 0; margin: 15px; padding-top: 10px">
            <div class="icon-wrapper rounded-circle">
              <i class="lnr-checkmark-circle"></i></div>
            <div class="widget-chart-content">
              <div class="widget-subheading">Qtd. Disponível</div>
              <div class="widget-numbers text-success"><span>{{ form.quantityAvailable }}</span></div>

            </div>
          </div>
        </div>
      </div>

    </transition>


    <transition v-else name="fade">

      <div class="mt-2">

        <b-row class="mb-1">

          <b-col cols="4">

            <b-link @click="searchByType = ''">
              <b-icon-arrow-left-circle class="mr-1"></b-icon-arrow-left-circle>
              Voltar
            </b-link>

          </b-col>

          <b-col cols="4" class="text-left">

            <b-card-title v-if="searchByType === 'stock'">EXTRATO EM ESTOQUE</b-card-title>

            <b-card-title v-else>EXTRATO DISPONÍVEL</b-card-title>

          </b-col>

        </b-row>

        <div style="overflow: hidden; position: relative; float: left; width: 100%">

          <t-table
              @getPage="getPageSearchStock"
              :show="checkViewListTableDefault()"
              :filtered="filtered"
              :busy="!pageListIsLoaded"
              :user-auth="userAuth"
              :items="request.content"
              :fields="fields"
              :total-pages="request.totalPages"
              :total-elements="request.totalElements"
              :container-table-style="[{'min-height':'250px'}]"
              link-primary-column="originCodeLabel"
              table-bordered
              disable-actions-column
              primary-key-column="stockProductId" />

        </div>



      </div>

    </transition>


  </b-modal>

</template>
<script>
import StockProductService from "@/services/modules/stock/StockProduct.service";
import {crudGeneral} from "@/services/resource/GeneralCRUD.service";
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin";
import pageListMixin from "@/mixins/page/pageListMixin";
import pageDialogFormMixin from "@/mixins/page/pageDialogFormMixin";

export default {
  name: "StockProductDialog",
  mixins: [pageDefaultMixin, pageListMixin, pageDialogFormMixin],
  data() {
    return {
      id: "modal-stock-product",
      title: "Estoque do Produto",
      path: "stock/product",
      filtered: false,
      searchParamsStock: null,
      searchByType: "",
      form: {
        stockPlaceProductId: 0,
        stockPlaceProductInsideId: 0,
        stockPlaceProduct: 0,
        stockPlaceProductInside: "",
        quantityStock: 0,
        quantityAvailable: 0,
        quantityReserved: 0.0,
        quantityTotal: 0,
        quantityUsed: 0.0,
        producedWeightStock: 0,
        product: {
          productId: 0,
          productCodeLabel: "",
          groupProductId: 0,
          unitId: 0,
          modelId: 0,
          name: "",
          unit: "",
          unitFull: "",
          model: "",
          groupProduct: ""
        },
      },
      fields: [
        {key: "originCodeLabel", label: "Origem"},
        {key: "stockPlaceProductInside", label: "Localização"},
        {key: "quantityStock", label: "Qtd. Estoque", formatter: "number"},
        {key: "quantityReserved", label: "Qtd. Reservada", formatter: "number"},
        {key: "quantityAvailable", label: "Qtd. Disponível", formatter: "number"},
        {key: "issueDate", label: "Data de Emissão", formatter: "date"},
      ],
    }
  },
  props: {
    productId: {
      type: Number,
      required: true,
    },
    stockPlaceProductInsideId: {
      type: Number,
      default: 0,
    },
  },
  methods: {

    extractStock() {
      this.searchStock('stock')
    },

    extractReserved() {

      this.$bvModal.msgBoxOk("Nenhuma reservada realizada", {
        title: "Informação",
        okVariant: 'info',
        okTitle: 'Ok',
        hideHeaderClose: false,
      })

    },

    extractAvailable() {
      this.searchStock('available')
    },

    //Declaro sempre localmente, pois poderá realizar operações diferentes do padrão como setar algum valor padrão vindo de fora e que seria limpo pelo resetModal de forma dinamica
    async showModal() {

      this.busy = true

      //Limpa os campos
      this.resetModal()

      //Setar alguma informações padrão por exemplo vindo de fora

      await StockProductService.getResume(this.productId, this.stockPlaceProductInsideId).then(response => {

        this.form = response

        if (this.stockPlaceProductInsideId === 0)
          this.form.stockPlaceProductInside = "Todos estoques"

        this.busy = false

      })

    },

    async searchStock(type = "available") {

      this.filtered = true
      this.searchByType = type

      let params = new URLSearchParams()
      params.set("pageSize", "5")
      params.set("productId", ""+this.productId)

      if(this.stockPlaceProductInsideId > 0)
        params.set("stockPlaceProductInsideId","" + this.stockPlaceProductInsideId)

      if(type === 'available'){
        params.set("quantityAvailable","min(1)")
      }else if(type === 'stock'){
        params.set("quantityStock","min(1)")
      }

      this.searchParamsStock = params

      await this.getPageSearchStock(1)


    },

    async getPageSearchStock(pageNumber, finishLoaded = true) {

      this.pageListIsLoaded = false

      //DEVERÁ MONTAR OS PARÂMETROS DINAMICAMENTE CONFORME OS CAMPOS FOREM MARCADOS COMO DE PESQUISA
      await crudGeneral.getAll(this.path + "/extract", pageNumber, this.searchParamsStock)
          .then(response => {

            this.request = response.data

            if (finishLoaded)
              this.pageListIsLoaded = true

          })
          .catch(error => {
            console.log('Erro externo: ' + error)
          })


    },

  }
}
</script>
<style>
.container_stock_total:hover {
  cursor: pointer;
  border-color: var(--template-color-primary) !important;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1) !important;
}

</style>
